import { useNavigate, useSearchParams } from "react-router-dom";
import Localization from "../../../localization";
import { AuthApi } from "../../../apis";
import { useApi } from "../../../hooks";
import { useRef } from "react";

const fields = [
  {
    type: "password",
    name: ["password"],
    rules: [{ min: 4, required: true }],
    label: Localization.general.new_password,
    placeholder: Localization.general.type_password,
  },
  {
    type: "password",
    dependencies: ["password"],
    name: ["confirm_password"],
    label: Localization.general.confirm_password,
    placeholder: Localization.general.type_password,
    rules: [
      { required: true, message: "" },
      ({ getFieldValue }) => ({
        validator(_, value) {
          return getFieldValue("password") === value
            ? Promise.resolve()
            : Promise.reject(
                new Error(Localization.feedback.unmatched_password)
              );
        },
      }),
    ],
  },
];

const useViewModel = () => {
  const [params] = useSearchParams();
  const token = params.get("token");
  const email = params.get("email");
  const navigate = useNavigate();
  const { execute } = useApi();
  const formRef = useRef();

  const resetPassword = async () => {
    try {
      await formRef.current.validateFields();
      await execute(
        () =>
          AuthApi.resetPassword(token, {
            email,
            password: formRef.current.getFieldValue("password"),
          }),
        {
          success: Localization.formatString(
            Localization.reset_password.success_feedback,
            email
          ),
        }
      );
      navigate("/");
    } catch (error) {}
  };

  return {
    email,
    fields,
    refs: { form: formRef },
    invalidLink: !email || !token,
    resetPassword,
  };
};

export default useViewModel;
